import { SmartTable } from '../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state, Alert, ApplicationsResource) {
        this.$state = $state;
        this.Alert = Alert;
        this.ApplicationsResource = ApplicationsResource;
    }

    $onInit() {
        if (this.$state.rolesEdited) {
            this.reloadApp(this.companyId, this.application.id, this.ApplicationsResource);
            this.$state.rolesEdited = false;
        }
        this.st = new SmartTable();
        this.isAws = this.is('aws');
        this.isSaaspassDemo = this.is('saaspass-demo');
        this.isSaaspassMySqlConnector = this.is('saaspass-my-sql-connector');
        this.selectedRoles = this.groups.reduce((groupIds, group) => ({
            ...groupIds,
            [group.id]: this.application.loginRoles.reduce((roleIds, {loginRoleId}) => (
                {...roleIds, [loginRoleId]: false}
            ), {})
        }), {});
    }

    is(...types) {
        return types.includes(this.application.applicationType.slug);
    }

    assign() {
        const data = this.st.selectedIds.map((groupId) => ({
            groupId,
            roleIds: this.selectedRolesForGroup(groupId).map((role) => role.loginRoleId)
        }));

        this.isSaving = true;
        this.ApplicationsResource
            .assignGroups(this.companyId, this.application.id, data)
            .then(() => this.$state.go('^', {}, {reload: '^'}))
            .then(() => this.Alert('success', 'company.manage-application.users.assign-groups.assigned'))
            .finally(() => this.isSaving = false)
    }

    selectedRolesForGroup(groupId) {
        return this.application.loginRoles
            .filter((role) => this.selectedRoles[groupId][role.loginRoleId])
    }

    selectedRoleNamesForGroup(groupId) {
        return this.selectedRolesForGroup(groupId)
            .map((role) => role.loginRoleName)
            .join(', ')
    }

    reloadApp(companyId, appId, ApplicationsResource) {
        ApplicationsResource
        .getApplicationConfiguration(companyId, appId)
        .then(app => {
            this.application = app;
        })
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/users/assign-groups/assign-groups.controller.js